let now = new Date().getTime();
export const nextId = () => {
  return ++now;
}